import { Box, styled } from '@mui/material'

export const PageContent = styled(Box)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2),
  },
  flex: 1,
  overflow: 'hidden',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
}))
